import BOOKING from "./types";

const init = () => {
  return {
    bookingMap: new Map([
      [
        698723, // 698733
        {
          status: "rejected", // pending,accepted,rejected,onboarding_requested,rc_sent,rc_confirmed,shipment_picked_up
          rejecter: "system", // carrier,broker_reject,broker_cancel,system
          bookingId: "",
          rcFiles: [],
        },
      ],
    ]),
    updatedTime: Date.now()
  };
};

const reducer = (state, action) => {
  if (action.error || action.pending) return state;
  switch (action.type) {
    case BOOKING.BOOKING_DELETE: {
      // 删除bookingmap
      if (!state.bookingMap.has(action.payload.loadId)) return state;

      state.bookingMap.delete(action.payload.loadId);

      return {
        bookingMap: new Map(state.bookingMap),
        updatedTime: Date.now()
      };
      // return {
      //   bookingMap: new Map(),
      // };
    }
    case BOOKING.BOOKING_CANCEL: {
      // 取消等待中的booking
      if (!state.bookingMap.has(action.payload.loadId)) return state;

      const value = state.bookingMap.get(action.payload.loadId);
      value["status"] = "rejected";
      value["rejecter"] = "carrier";
      state.set(action.payload.loadId, value);

      return {
        bookingMap: new Map(state.bookingMap),
        updatedTime: Date.now()
      };
    }
    case BOOKING.BOOKING_CREATE: {
      // 创建booking
      state.bookingMap.set(action.payload.loadId, {
        status: "pending",
        rejecter: "",
        bookingId: action.payload.bookingId,
      });

      return {
        bookingMap: new Map(state.bookingMap),
        updatedTime: Date.now()
      };
    }
    case BOOKING.BOOKING_GET: {
      // 获取mybooking列表
      return {
        bookingMap:
          action.payload && Array.isArray(action.payload)
            ? new Map(
                action.payload.map(
                  ({ shipment_id, status, id, rejecter, attached_files,  status_key}) => [
                    shipment_id,
                    {
                      status,
                      bookingId: id,
                      rejecter,
                      rcFiles: attached_files.map(
                        (item) =>
                          item.type &&
                          item.type === "rate_confirmation" &&
                          item.url
                      ),
                      bookType: status_key
                    },
                  ]
                )
              )
            : new Map(),
            updatedTime: Date.now()
      };
    }
  }

  return null;
};

export default { reducer, init };



// WEBPACK FOOTER //
// ./src/modules/bookings/reducer.js